import i18n from '@/i18n'
import { COMPANY_ADMIN_MENU_GROUP_KEY } from '@/constant/company'
import Layout from '../layout.vue'
import Index from './index'
import Editor from './editor/index'

const basePath = '/v-admin/job-posting-management'

export default {
  path: basePath,
  redirect: `${basePath}/list`,
  component: Layout,
  meta: {
    permission: ['PERM_RPA_JOB_POSTING_MANAGEMENT', 'PREMIUM_RPA_JOB_POSTING'],
    isAllInclude: true,
    isNewPage: true,
    titleI18nKey: 'admin.company.jobPosting.title.index',
    menu: {
      get label () {
        return i18n.t('admin.company.jobPosting.title.index')
      },
      group: COMPANY_ADMIN_MENU_GROUP_KEY.RECRUIT
    }
  },
  children: [
    {
      path: `${basePath}/list`,
      component: Index,
      meta: {
        breadcrumb: { hidden: true },
        titleI18nKey: 'admin.company.jobPosting.title.index'
      }
    },
    {
      path: `${basePath}/:channelId/:fieldType/edit`,
      component: Editor,
      meta: {
        titleI18nKey: 'admin.company.jobPosting.title.editor'
      }
    }
  ]
}
